import { render, staticRenderFns } from "./TablePaquetes.vue?vue&type=template&id=eed56548"
import script from "./TablePaquetes.vue?vue&type=script&lang=js"
export * from "./TablePaquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports